var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemplates(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.52 5.128l-.111 3.59s-.144 2.373-2.76 2.086l-2.242-.06v10.198c0 .228.186.411.413.411h11.523a.411.411 0 00.411-.41V5.538a.412.412 0 00-.411-.411zm-.108-1.646h6.93c1.137 0 2.06.921 2.06 2.057v15.403A2.058 2.058 0 0116.341 23H4.82a2.057 2.057 0 01-2.058-2.058V10.498l.815-.86v-.024l4.271-4.486h-.012L6.695 6.332 7.89 5.065h.016l.038-.04h.004zM12.019 1H21.238v16.837h-1.625V2.447H12.02z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplates);
export default ForwardRef;